<template>
  <div class="shipping-calculator relative mb-3">
    <fade-transition>
      <overlay
        v-show="loading"
        absolutely-positioned
        data-cy="calculator-loader" />
    </fade-transition>
    <div v-show="!loading">
      <select-input
        v-model="country"
        class="mb-4"
        :options="countries"
        :label="t('shipping-calculator.destination-country')"
        dropdown-id="calculator-dropdown"
        icon-key="flag_image"
        value-key="iso"
        content-key="name" />

      <select-input
        v-if="regions.length"
        v-model="region"
        class="mb-4"
        :options="regions"
        :label="t('shipping-calculator.destination-region')"
        dropdown-id="calculator-dropdown"
        value-key="code"
        content-key="name" />

      <div :key="key">
        <select-input
          v-model="option"
          :options="availableOptions"
          :label="t('shipping-calculator.delivery-option')"
          dropdown-id="calculator-option-dropdown"
          value-key="id"
          content-key="name" />
      </div>

      <div class="text-left bg-paper p-6 my-6">
        <h3 class="mb-3 typeset-4">
          {{ t("shipping-calculator.estimated-arrival") }}
        </h3>
        <h4 class="typeset-6">
          <template v-if="isRange">
            {{ deliveryDate }} – {{ deliveryDateMax }}
          </template>
          <template v-else>{{ deliveryDate }}</template>
        </h4>
        <p class="typeset-7 text-ink">
          {{ numberOfDays }}
        </p>
        <div class="mt-4 pt-4 border-t border-paper-5 typeset-8 text-ink-4">
          <div v-html="itemCreationTime"></div>
          <div v-html="shippingTime"></div>
        </div>
      </div>

      <div class="typeset-7 text-ink">
        <h3 class="typeset-6 mb-2">
          {{ t("shipping-calculator.bottom-section.header") }}
        </h3>
        <p class="typeset-7 mb-3">{{ bottomSectionDescription }}</p>
        <a
          :href="bottomSectionLink"
          class="cursor-pointer underline">
          {{ t("shipping-calculator.bottom-section.cta-text") }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api/shipping/calculator";

import FadeTransition from "../transitions/FadeTransition.vue";
import Overlay from "../shared/Overlay.vue";
import SelectInput from "../shared/SelectInput.vue";

export default {
  name: "ShippingCalculator",
  components: {
    FadeTransition,
    Overlay,
    SelectInput
  },
  props: {
    id: {
      type: String,
      required: true
    },
    countries: {
      type: Array,
      required: true
    },
    defaultCountry: {
      type: String,
      required: true
    },
    defaultRegion: {
      type: String,
      required: false,
      default: null
    },
    productType: {
      type: String,
      required: true
    },
    delayed: {
      type: Boolean,
      required: true
    },
    quantity: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: true,
      deliveryDate: null,
      deliveryDateMax: null,
      isRange: false,
      numberOfDays: null,
      itemCreationTime: null,
      shippingTime: null,
      country: null,
      region: null,
      regions: [],
      option: null,
      availableOptions: [],
      key: 0
    };
  },
  computed: {
    bottomSectionDescription() {
      return this.productType === "StockItem"
        ? this.t("shipping-calculator.bottom-section.stock-items.description")
        : this.t("shipping-calculator.bottom-section.products.description");
    },
    bottomSectionLink() {
      return `${window.countryCode}/shipping`;
    }
  },
  watch: {
    country() {
      this.option = null;
      this.refreshCalculator();
    },
    region() {
      this.refreshCalculator();
    },
    option() {
      this.refreshCalculator();
    }
  },
  created() {
    this.country = this.defaultCountry;
    this.region = this.defaultRegion || "NY";
    this.refreshCalculator();
  },
  methods: {
    refreshCalculator() {
      this.loading = true;
      api
        .show(this.id, this.country, this.option, this.quantity, this.region)
        .then(response => {
          this.loading = false;
          this.deliveryDate = response.data.delivery_date;
          this.deliveryDateMax = response.data.delivery_date_max;
          this.isRange = response.data.is_range;
          this.numberOfDays = response.data.number_of_days;
          this.itemCreationTime = response.data.item_creation_time;
          this.shippingTime = response.data.shipping_time;
          this.option = response.data.shipping_option.id;
          this.availableOptions = response.data.available_shipping_options;
          this.regions = response.data.regions || [];
          this.key += 1;
        });
    }
  }
};
</script>
